"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var win = window, doc = win.document, localStorageName = 'localStorage', globalStorageName = 'globalStorage';
var LocalStorage = /** @class */ (function () {
    function LocalStorage() {
        if (localStorageName in win && win[localStorageName]) {
            this.storage = win[localStorageName];
        }
        else if (globalStorageName in win && win[globalStorageName]) {
            this.storage = win[globalStorageName][win.location.hostname];
        }
        else if (window.doc.documentElement.addBehavior) {
            var storageTem = void 0;
            if (this.storage) {
                storageTem = this.storage;
            }
            else {
                storageTem = doc.body.appendChild(doc.createElement('div'));
                storageTem.style.display = 'none';
                storageTem.addBehavior('#default#userData');
                storageTem.load(localStorageName);
            }
            this.storage = storageTem;
        }
    }
    LocalStorage.prototype.Set = function (key, val) {
        this.ActionInterface(ActionType.SetStorage, key, val);
    };
    LocalStorage.prototype.Get = function (key) {
        return this.ActionInterface(ActionType.GetStorage, key);
    };
    ;
    LocalStorage.prototype.Remove = function (key) {
        this.ActionInterface(ActionType.RemoveStorage, key);
    };
    ;
    LocalStorage.prototype.Clear = function () {
        this.ActionInterface(ActionType.ClearStorage);
    };
    ;
    LocalStorage.prototype.ActionInterface = function (actionType, key, val) {
        var storage;
        if (localStorageName in win && win[localStorageName]) {
            storage = win[localStorageName];
            switch (actionType) {
                case ActionType.SetStorage:
                    storage.setItem(key, val);
                    break;
                case ActionType.GetStorage:
                    return storage.getItem(key);
                case ActionType.RemoveStorage:
                    storage.removeItem(key);
                    break;
                case ActionType.ClearStorage:
                    storage.clear();
                    break;
            }
        }
        else if (globalStorageName in win && win[globalStorageName]) {
            storage = win[globalStorageName][win.location.hostname];
            switch (actionType) {
                case ActionType.SetStorage:
                    storage[key] = val;
                    break;
                case ActionType.GetStorage:
                    return storage[key] && storage[key].value;
                case ActionType.RemoveStorage:
                    delete storage[key];
                    break;
                case ActionType.ClearStorage:
                    for (var key in storage) {
                        delete storage[key];
                    }
                    break;
            }
        }
        else if (window.doc.documentElement.addBehavior) {
            var storageTem = void 0;
            if (storage) {
                storageTem = storage;
            }
            else {
                storageTem = doc.body.appendChild(doc.createElement('div'));
                storageTem.style.display = 'none';
                storageTem.addBehavior('#default#userData');
                storageTem.load(localStorageName);
            }
            storage = storageTem;
            switch (actionType) {
                case ActionType.SetStorage:
                    storage.setAttribute(key, val);
                    storage.save(localStorageName);
                    break;
                case ActionType.GetStorage:
                    return storage.getAttribute(key);
                case ActionType.RemoveStorage:
                    storage.removeAttribute(key);
                    storage.save(localStorageName);
                    break;
                case ActionType.ClearStorage:
                    var attributes = storage.XMLDocument.documentElement.attributes;
                    storage.load(localStorageName);
                    for (var i = 0, attr; attr = attributes[i]; i++) {
                        storage.removeAttribute(attr.name);
                    }
                    storage.save(localStorageName);
                    break;
            }
        }
    };
    return LocalStorage;
}());
exports.LocalStorage = LocalStorage;
var ActionType;
(function (ActionType) {
    ActionType[ActionType["SetStorage"] = 0] = "SetStorage";
    ActionType[ActionType["GetStorage"] = 1] = "GetStorage";
    ActionType[ActionType["RemoveStorage"] = 2] = "RemoveStorage";
    ActionType[ActionType["ClearStorage"] = 3] = "ClearStorage";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
var DownLoadObjFull = /** @class */ (function () {
    function DownLoadObjFull() {
        this.FileUrl = "";
        this.FileName = "";
        this.FileSize = "";
        this.Version = "";
        this.ReleaseDate = "";
        this.Product = "";
        this.DSName = ""; //Title
        this.Selected = false;
        this.FileType = -1;
        //public FileId = "";
        //public FileUrl = "";
        //public FileName = "";
        //public FileSize = "";
        //public Version = "";
        //public ReleaseDate = "";
        //public LastUpdate = "";
        //public Img = "";
        //public Title = "";//DSName
        //public DownLoadUrl = "";
        //public Product = "";
        //public Category = "";
        //public CategoryClass = "";
        //public Selected = false;
    }
    return DownLoadObjFull;
}());
exports.DownLoadObjFull = DownLoadObjFull;
;
